import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Layout2 from './components/Layout/Layout2';
import Layout3 from './components/Layout/Layout3';
import Layout4 from './components/Layout/Layout4';
import Home from './components/Pages/Home';
import HomeStyle2 from './components/Pages/HomeStyle2';
import HomeStyle3 from './components/Pages/HomeStyle3';
import HomeStyle4 from './components/Pages/HomeStyle4';
import About from './components/Pages/About';
import Clinicians from './components/Pages/Clinicians';
import Blog from './components/Pages/Blog';
import Appointments from './components/Pages/Appointments';
import Departments from './components/Pages/Departments';
import DepartmentDetails from './components/Pages/DepartmentDetails';
import BlogDetails from './components/Pages/BlogDetails';
import DoctorDetails from './components/Pages/DoctorDetails';
import PricingPlan from './components/Pages/PricingPlan';
import Gallery from './components/Pages/Gallery';
import Timetable from './components/Pages/Timetable';
import Contact from './components/Pages/Contact';
import { useEffect } from 'react';
import ErrorPage from './components/Pages/ErrorPage';
import PrivacyPolicy from './components/Pages/PrivacyPolicy';
import Layout5 from './components/Layout/Layout5';
import HomeStyle5 from './components/Pages/HomeStyle5';
import HomeStyle6 from './components/Pages/HomeStyle6';
import Corporate from './components/Pages/Corporate';
import LifeAtCelbion from './components/Pages/LifeAtCelbion';
import ResearchAndDevelopment from './components/Pages/ResearchAndDevelopment';
import Foundation from './components/Pages/Foundation';
import MessageFromCEO from './components/Pages/MessageFromCEO';
import BusinessDevelopment from './components/Pages/BusinessDevelopment';
import PartnerWithUs from './components/Pages/PartnerWithUs';
import OurAwards from './components/Pages/OurAwards';
import ProductPortfolio from './components/Pages/ProductProtfolio';
// import TrainingDevelopment from './components/Pages/TrainingDevelopment';
import Brand from './components/Pages/Brand';
import ScientificNetworking from './components/Pages/ScientificNetworking';
import ScientifiCommunity from './components/Pages/ScientifiCommunity';
import Events from './components/Pages/Events';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="clinicians" element={<Clinicians />} />
        <Route path="doctors/:doctorId" element={<DoctorDetails />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:blogId" element={<BlogDetails />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="departments" element={<Departments />} />
        <Route path="our-award" element={<OurAwards />} />
        <Route path="productprotfoilio" element={<ProductPortfolio />} />
        {/* <Route path="traning-development" element={<TrainingDevelopment />} /> */}
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="scientific-networking" element={<ScientificNetworking />} />
        <Route path="scientifi-community" element={<ScientifiCommunity />} />
        <Route path="brand" element={<Brand />} />
        <Route path="events" element={<Events />} />
        <Route
          path="departments/:departmentId"
          element={<DepartmentDetails />}
        />
        <Route path="pricing-plan" element={<PricingPlan />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="timetable" element={<Timetable />} />
        <Route path="contact" element={<Contact />} />
        <Route path="message-from-ceo" element={<MessageFromCEO />} />
        <Route path="#" element={<BusinessDevelopment />} />
        <Route path="partner-with-us" element={<PartnerWithUs />} />
        <Route path="corporate" element={<Corporate />} />
        <Route path="foundation" element={<Foundation />} />
        {/* <Route path="research" element={<ResearchAndDevelopment />} /> */}
        <Route path="celbionculture" element={<ResearchAndDevelopment />} />
        <Route path="life-at-celbion" element={<LifeAtCelbion />} />
      </Route>
      <Route element={<Layout2 />}>
        <Route path="home-v2" element={<HomeStyle2 />} />
        <Route path="home-v6" element={<HomeStyle6 />} />
      </Route>
      <Route path="home-v3" element={<Layout3 />}>
        <Route index element={<HomeStyle3 />} />
      </Route>
      <Route path="home-v4" element={<Layout4 />}>
        <Route index element={<HomeStyle4 />} />
      </Route>
      <Route path="home-v5" element={<Layout5 />}>
        <Route index element={<HomeStyle5 />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
